const commonImages = {
  weekByWeek: {
    4: {
      src: require('./week-by-week/WBW_Week4_RainbowSprinkle.png'),
      alt:
        "rainbow sprinkle: The start of the embryonic period.",
    },
    5: {
      src: require('./week-by-week/WBW_Week5_SugarPearl.png'),
      alt: 'sugar pearl: Your first missed period and positive pregnancy test',
    },
    6: {
      src: require('./week-by-week/WBW_Week6_ChocolateChip.png'),
      alt: "chocolate chip: Baby's heart is beating alongside yours now!",
    },
    7: {
      src: require('./week-by-week/WBW_Week7_CandyHeart.png'),
      alt: "candy heart: Think fast, brain cells are forming like crazy!",
    },
    8: {
      src: require('./week-by-week/WBW_Week8_JellyBean.png'),
      alt:
        'jelly bean: Your baby has developed limbs.',
    },
    9: {
      src: require('./week-by-week/WBW_Week9_GummyBear.png'),
      alt: 'gummy bear: Your baby is a fetus!',
    },
    10: {
      src: require('./week-by-week/WBW_Week10_Gumball.png'),
      alt: 'gum ball: Major organs are starting to function!',
    },
    11: {
      src: require('./week-by-week/WBW_Week11_ChocolateTruffle.png'),
      alt:
        "chocolate truffle: Genitals are slowly starting to form.",
    },
    12: {
      src: require('./week-by-week/WBW_Week12_Macaron.png'),
      alt: 'macaron: Your baby is developing their reflexes. ',
    },
    13: {
      src: require('./week-by-week/WBW_Week13_BlossomCookie.png'),
      alt:
        'blossom cookie: fingerprints, vocal cords, & tiny teeth - OH MY! ',
    },
    14: {
      src: require('./week-by-week/WBW_Week14_FrostedCookie.png'),
      alt:
        "frosted cookie: 2nd Trimester celebration!",
    },
    15: {
      src: require('./week-by-week/WBW_Week15_Donut.png'),
      alt: 'donut: Baby can see & react to light.',
    },
    16: {
      src: require('./week-by-week/WBW_Week16_Cannoli.png'),
      alt:
        'cannoli: Your baby can hear & recognize your voice, loud & clear!',
    },
    17: {
      src: require('./week-by-week/WBW_Week17_Eclair.png'),
      alt:
        'eclair: Cartilage is hardening into bone. ',
    },
    18: {
      src: require('./week-by-week/WBW_Week18_CheeseDanish.png'),
      alt: 'cheese danish: Hiyah! Can you feel those kicks yet?',
    },
    19: {
      src: require('./week-by-week/WBW_Week19_JumboCupcake.png'),
      alt:
        "jumbo cupcake: Huge developments of the five senses! ",
    },
    20: {
      src: require('./week-by-week/WBW_Week20_ChocolateCroissant.png'),
      alt: "chocolate croissant: Half way to your due date!",
    },
    21: {
      src: require('./week-by-week/WBW_Week21_GiantCaramelApple.png'),
      alt: 'giant caramel apple: Meconium is forming in the digestive system.',
    },
    22: {
      src: require('./week-by-week/WBW_Week22_BelgianWaffles.png'),
      alt:
        'belgian waffle stack: Baby is busy growing a layer of fat for warmth!',
    },
    23: {
      src: require('./week-by-week/WBW_Week23_CinnamonRoll.png'),
      alt:
        'cinnamon roll: Baby can recognize sounds & sense your movement!',
    },
    24: {
      src: require('./week-by-week/WBW_Week24_PoundCake.png'),
      alt: "pound cake: Baby's skin is turning pink and soft, too cute!",
    },
    25: {
      src: require('./week-by-week/WBW_Week25_MiniChocolatePie.png'),
      alt:
        "mini chocolate pie: Your partner can hear baby's heartbeat against your belly.",
    },
    26: {
      src: require('./week-by-week/WBW_Week26_IceCreamSundae.png'),
      alt: "ice cream sundae: Your baby's eyes are open and letting the light in!",
    },
    27: {
      src: require('./week-by-week/WBW_Week27_PeachCobbler.png'),
      alt: 'peach cobbler: Baby is fully equipped for life outside the womb!',
    },
    28: {
      src: require('./week-by-week/WBW_Week28_Strudle.png'),
      alt:
        "strudle: 3rd Trimester! You're in the home stretch!",
    },
    29: {
      src: require('./week-by-week/WBW_Week29_CinnamonCake.png'),
      alt:
        'cinnamon cake: Baby is growing fast and sitting right on your digestive tract.',
    },
    30: {
      src: require('./week-by-week/WBW_Week30_RaspberryTart.png'),
      alt: "raspberry tart: Baby is strong enough to grip a finger!",
    },
    31: {
      src: require('./week-by-week/WBW_Week31_StrawberryCake.png'),
      alt: 'strawberry cake:  Baby is very active, on average delivering ten kicks per hour.',
    },
    32: {
      src: require('./week-by-week/WBW_Week32_StackOfBrownies.png'),
      alt:
        "stack of brownies: Baby is practicing breathing motions in preparation for the big day!",
    },
    33: {
      src: require('./week-by-week/WBW_Week33_BananaBread.png'),
      alt:
        "banana bread: Baby is upside down to increase blood flow to their brain to fuel growth!",
    },
    34: {
      src: require('./week-by-week/WBW_Week34_BostonCreamPie.png'),
      alt:
        "boston cream pie: Your baby knows your voice and your partner's.",
    },
    35: {
      src: require('./week-by-week/WBW_Week35_ApplePie.png'),
      alt: "apple pie: Time to set up your birth plan.",
    },
    36: {
      src: require('./week-by-week/WBW_Week36_Cheesecake.png'),
      alt: 'cheesecake: One more month! You got this, mama!',
    },
    37: {
      src: require('./week-by-week/WBW_Week37_Trifle.png'),
      alt: 'trifle: Relax, relax, relax & then relax some more!',
    },
    38: {
      src: require('./week-by-week/WBW_Week38_BundtCake.png'),
      alt:
        "bundt cake: You're almost there!",
    },
    39: {
      src: require('./week-by-week/WBW_Week39_CarrotCake.png'),
      alt: 'carrot cake: Watch for signs of labor!',
    },
    40: {
      src: require('./week-by-week/WBW_Week40_BirthdayCake.png'),
      alt: 'birthday cake: Due date week is here! AHH!!',
    },
    41: {
      src: require('./week-by-week/WBW_Week41_2-TierBirthdayCake.png'),
      alt:
        "double layer birthday cake: Late-term pregnancy",
    },
    42: {
      src: require('./week-by-week/WBW_Week42_3-TierBirthdayCake.png'),
      alt: 'triple layer birthday cake : You made it!!!!!',
    },
    main: {
      src: require('./week-by-week/Main-image.png'),
      alt:
        'Bump Boxes 40 week pregnancy updates showing various cartoon drawings of food items.',
    },
  },
};

export default commonImages;
